import { ButtonSize, TextInputSize } from 'lego-on-react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { phrasesSelectorChangeInput } from '../../actions/phrasesSelectorWizard';
import {
    PhrasesSelectorWizardInput,
    PhrasesSelectorWizardInputProps
} from '../../components/PhrasesSelectorWizard/PhrasesSelectorWizardInput/PhrasesSelectorWizardInput';
import { selectPhrasesSelectorInputData } from '../../selectors/phrasesSelectorWizard/phrasesSelectorWizard';
import { PhrasesSelectorInputColumns, PhrasesSelectorWizardId } from '../../typings/phrases';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export interface OwnProps {
    wizardId: PhrasesSelectorWizardId;
    onSubmit: (value: string) => void;
    type: PhrasesSelectorInputColumns;
    buttonSize: ButtonSize;
    inputSize: TextInputSize;
    placeholder: string;
    cls: string;
    buttonText: string;
}

type StateProps = TStateProps<PhrasesSelectorWizardInputProps, OwnProps>;
type DispatchProps = TDispatchProps<PhrasesSelectorWizardInputProps, OwnProps>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { wizardId, type } = ownProps;
    const { value, error } = selectPhrasesSelectorInputData(state, wizardId, type);
    return {
        value,
        error
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    return {
        onChange: value => {
            dispatch(phrasesSelectorChangeInput(ownProps.wizardId, value, ownProps.type));
        }
    };
};

export const PhrasesSelectorWizardInputContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    PhrasesSelectorWizardInputProps
>(
    mapStateToProps,
    mapDispatchToProps,
    (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: OwnProps): PhrasesSelectorWizardInputProps => {
        return {
            ...stateProps,
            ...dispatchProps,
            ...ownProps
        };
    }
)(PhrasesSelectorWizardInput);
